import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiUrl } from "../../constants";

export const getPackagingList = createAsyncThunk(
  "packagingList/getPackagingList",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        `${apiUrl}/get_packaging_list`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Fetching packaging list failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const packagingListSlice = createSlice({
  name: "packagingList",
  initialState: {
    list: [],
    totalVolume: 0.0,
    minTrunkDimensions: 0.0,
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    clearPackagingList: (state) => {
      state.list = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPackagingList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getPackagingList.fulfilled, (state, action) => {
        state.status = "success";
        state.list = action.payload.packages;
        state.totalVolume = action.payload.total_volume;
        state.minTrunkDimensions = action.payload.min_trunk_inner_dimensions;
      })
      .addCase(getPackagingList.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
        state.list = [];
      });
  },
});

export const { clearPackagingList } = packagingListSlice.actions;
export default packagingListSlice.reducer;
